import { SizableText, SmartLink, XStack, colors, styled } from '@my/ui'
import { CategoryTabsQueryOutput } from './queries'

const TabButton = styled(XStack, {
  position: 'relative',
  ai: 'center',
  borderRadius: '$3',
  py: '$2',
  px: '$3',
  width: 'auto',
  bg: '$white',
  gap: '$2',
  borderWidth: 1,
  borderColor: '$grey3',
  hoverStyle: {
    opacity: 0.9,
    bg: '$primary4',
  },
  focusStyle: {
    opacity: 0.9,
    bg: '$primary4',
  },
  pressStyle: {
    opacity: 0.6,
    bg: '$primary4',
  },
  variants: {
    active: {
      true: {
        opacity: 1,
        bg: '$primary',
        hoverStyle: {
          bg: '$primary4',
        },
        pressStyle: {
          bg: '$primary5',
        },
        focusStyle: {
          bg: '$primary4',
        },
      },
    },
  } as const,
})

export type CategoryTabsItemProps = CategoryTabsQueryOutput['ArticleCategories']['docs'][0] & {
  href: string
  selected?: boolean
}

export const CategoryTabsItem = (props: CategoryTabsItemProps) => {
  return (
    <XStack>
      <SmartLink Component={TabButton} href={props.href} active={props.selected}>
        <SizableText size="$3" fow="600" color={props.selected ? colors.black : colors.grey8}>
          {props.name}
        </SizableText>
      </SmartLink>
    </XStack>
  )
}
